import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type AppStoreCtaProps = CtaShellProps

export function AppStoreCta(props: AppStoreCtaProps) {
  return <CtaShell {...props} layout="centered" actionType="app-store" />
}
